import Env from "config/environment";

type Branch = {
  _q: [keyof Branch, IArguments][];
  init: (branchKey: string) => void;
};

declare global {
  interface Window {
    branch?: Branch;
  }
}

if (!window.branch?._q) {
  // We save the url of the entiry so that deep link handlers can use this later.
  (window as unknown as { initialLocation: string }).initialLocation = window.location.toString();

  const scriptElem = window.document.createElement("script");
  scriptElem.async = true;
  scriptElem.src = "https://cdn.branch.io/branch-latest.min.js";
  window.document.body.appendChild(scriptElem);

  const handlerKeys =
    "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(
      " ",
    ) as (keyof Branch)[];
  const branch = (window.branch = { _q: [], _v: 1 } as unknown as Branch);
  for (const handlerKey of handlerKeys) {
    branch[handlerKey] = function () {
      branch._q.push([handlerKey, arguments]); // eslint-disable-line prefer-rest-params
    } as any; // eslint-disable-line @typescript-eslint/no-explicit-any
  }

  branch.init(Env.branchApiKey);
}
